<div class='container'>

    <full-calendar
          [options]='calendarOptions()'>
    </full-calendar>

</div>


<!--

<full-calendar
  *ngIf="options"
  #fullcalendar
  [editable]="true"
  [events]="eventsModel"
  [header]="options.header"
  [locales]="options.locales"
  [locale]="options.locale"
  [customButtons]="options.customButtons"
  (dateClick)="dateClick($event)"
  (eventDragStop)="eventDragStop($event)"
  [plugins]="options.plugins"
  (dayRender)="dayRender($event,el)"
  (eventClick)="eventClick($event)"
  [columnHeaderHtml]="options.columnHeaderHtml"
></full-calendar>

-->
